import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { debounceTime, filter } from 'rxjs/operators';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarProductoComponent } from 'src/app/views/shared/modal-seleccionar-producto/modal-seleccionar-producto.component';
import { EquivalenciaProductoService } from 'src/app/services/equivalencia-producto.service';
import IEquivalenciaProducto, { IEquivalenciaProductoExtended } from 'src/app/shared/object/equivalencia-producto.model';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { FormatoProductosService } from 'src/app/services/formato-productos.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { ModalSeleccionarProveedorComponent } from '../../../shared/modal-seleccionar-proveedor/modal-seleccionar-proveedor.component';

@Component({
  selector: 'app-maestro-equivalencias-modal-add-edit',
  templateUrl: './modal-add-edit.component.html',
  styleUrls: ['../maestro-equivalencias.component.scss'],
  providers: [SecurityService],
})
export class ModalAddEditProductoEquivalenciaComponent implements OnInit {

  @Input() optionsProveedor: Array<any> = [];

  // Outputs
  @Output() onSuccess: EventEmitter<void> = new EventEmitter<void>()

  // Modales
  @ViewChild(ModalSeleccionarProveedorComponent, { static: true }) modalSeleccionarProveedor: ModalSeleccionarProveedorComponent
  @ViewChild('equivalenciasModal', { static: true }) modalProductoEquivalencias: ModalDirective;
  @ViewChild(ModalSeleccionarProductoComponent, { static: true }) modalSeleccionarProducto: ModalSeleccionarProductoComponent
  @Output() onProveedorChange: EventEmitter<any> = new EventEmitter<any>()

  // Form
  formHeader: FormGroup;
  initialValues: any

  // Data & Tmp
  rutEmpresa: number
  sucursalCodigo: number
  productoSeleccionado: any = null
  equivalencia_producto: IEquivalenciaProductoExtended
  // optionsFormato: any = []
  optionsFormato: Array<any> = [];
  proveedorSeleccionado: any = null
  headerData: any = {}

  // Data & Tmp
  mode: 'ADD' | 'EDIT'

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private messageRendererService: MessageRendererService,
    private formatoProductoService: FormatoProductosService,
    private rutService: RutService,
    private equivalenciaProductoService: EquivalenciaProductoService
  ) {
    this.log = this.clog.log('MAESTRO-EQUIVALENCIAS-ADD-EDIT')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());

    this.createFormInitialValues()
    this.createForms()
    this.formChangesSubscriptions()
  }

  createFormInitialValues() {
    this.initialValues = {
      cliente_proveedor_rut: null,
      producto_proveedor: null,
      detalle_producto: null,
      formato_codigo: null,
      factor_equivalencia: null,
      producto_sku: null,
      formato_codigo_top: null,
      activado: true,
      observacion: null,
    }
  }

  private createForms() {
    this.formHeader = this.fb.group({
      cliente_proveedor_rut: [null, [Validators.required]],
      producto_proveedor: [null, [Validators.required]],
      detalle_producto: [null, [Validators.required]],
      formato_codigo: [null, [Validators.required]],
      factor_equivalencia: [null, [Validators.required, Validators.min(1)]],
      producto_sku: [null, [Validators.required]],
      formato_codigo_top: [null, [Validators.required]],
      activado: [null, [Validators.required]],
      observacion: [null, [Validators.maxLength(200)]],
    });
  }

  formChangesSubscriptions() {
    this.formHeader.get("cliente_proveedor_rut").valueChanges
      .pipe(filter(Boolean), debounceTime(2500))
      .subscribe((cliente_proveedor_rut: string) => {
        this.modalSeleccionarProveedor.searchByRut(cliente_proveedor_rut)
      })

    this.formHeader.get("producto_sku").valueChanges
      .pipe(filter(Boolean), debounceTime(1000))
      .subscribe((codigo: string) => {
        this.log("producto_sku change", codigo)
        this.modalSeleccionarProducto.searchBySKU(codigo)
      })
  }

  show() {
    this.mode = 'ADD'

    // Limpiar completamente el estado
    this.equivalencia_producto = null
    this.productoSeleccionado = null
    this.proveedorSeleccionado = null
    this.optionsFormato = []

    this.setInitialValues()
    this.setCreateValidators()
    this.modalProductoEquivalencias.show()
  }

  loadAndshow(idEquivalencia: number) {
    this.mode = 'EDIT'
    this.log('setting', idEquivalencia)

    // Limpiar completamente el estado antes de cargar nuevos datos
    this.equivalencia_producto = null
    this.productoSeleccionado = null
    this.proveedorSeleccionado = null
    this.optionsFormato = []
    this.setInitialValues() // Limpiar formulario con valores iniciales

    this.equivalenciaProductoService.obtenerSegunId({
      id: idEquivalencia
    }, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      this.equivalencia_producto = respuesta
      const { fueUsadaEnTransaccion } = this.equivalencia_producto

      // Configurar proveedor seleccionado
      this.proveedorSeleccionado = {
        rut: this.equivalencia_producto.cliente_proveedor_rut,
        rutFormato: this.rutService.AgregarDV(this.equivalencia_producto.cliente_proveedor_rut)
      }

      // Configurar producto seleccionado
      this.productoSeleccionado = {
        codigo: this.equivalencia_producto.producto_codigo,
        descripcion: this.equivalencia_producto.producto_descripcion,
        sku: this.equivalencia_producto.producto_sku
      }

      // Establecer valores del formulario
      this.setInitialValues({
        cliente_proveedor_rut: this.rutService.AgregarDV(this.equivalencia_producto.cliente_proveedor_rut),
        producto_proveedor: this.equivalencia_producto.producto_proveedor,
        detalle_producto: this.equivalencia_producto.detalle_producto,
        formato_codigo: this.equivalencia_producto.formato_codigo,
        factor_equivalencia: this.equivalencia_producto.factor_equivalencia,
        producto_sku: this.equivalencia_producto.producto_sku,
        formato_codigo_top: this.equivalencia_producto.formato_codigo_top,
        activado: this.equivalencia_producto.activado,
        observacion: this.equivalencia_producto.observacion ? this.equivalencia_producto.observacion.trim() : '',
      })

      // Aplicar validadores según el estado de la equivalencia
      if (fueUsadaEnTransaccion) {
        this.setUpdateUsedValidators()
      } else {
        this.setUpdateEmptyValidators()
      }

      this.modalProductoEquivalencias.show()

      if (fueUsadaEnTransaccion) {
        this.modalSeleccionarProducto.searchBySKU(this.productoSeleccionado.sku)
        this.modalSeleccionarProveedor.searchByRut(this.proveedorSeleccionado.rutFormato)
      }
    })
  }

  private setCreateValidators() {
    this.formHeader.get('cliente_proveedor_rut').setValidators([Validators.required])
    this.formHeader.get('producto_proveedor').setValidators([Validators.required])
    this.formHeader.get('detalle_producto').setValidators([Validators.required])
    this.formHeader.get('formato_codigo').setValidators([Validators.required])
    this.formHeader.get('factor_equivalencia').setValidators([Validators.required])
    this.formHeader.get('producto_sku').setValidators([Validators.required])
    this.formHeader.get('formato_codigo_top').setValidators([Validators.required])
    this.formHeader.get('activado').setValidators([Validators.required])
    this.formHeader.get('observacion',).setValidators([Validators.maxLength(200)])
  }

  private setUpdateEmptyValidators() {
    this.setCreateValidators()
  }

  private setUpdateUsedValidators() {
    this.formHeader.get('activado').setValidators([Validators.required])
    this.formHeader.get('observacion').setValidators([Validators.required, Validators.maxLength(200)])
  }

  private setInitialValues(values = this.initialValues) {
    // Solo limpiar validadores si estamos estableciendo valores iniciales por defecto
    if (values === this.initialValues) {
      this.formHeader.clearValidators()
    }

    this.formValidatorsService.setInitialState(this.formHeader, values)

    // Limpiar modales de selección
    this.modalSeleccionarProducto.clearLast()
    this.modalSeleccionarProveedor.clearLast()

    // Limpiar opciones y selecciones
    this.optionsFormato = []

    // Solo limpiar selecciones si no estamos en modo edición o si no se pasaron valores específicos
    if (this.mode === 'ADD' || values === this.initialValues) {
      this.productoSeleccionado = null
      this.proveedorSeleccionado = null
    }
  }

  abrirModalSeleccionarProducto() {
    this.modalSeleccionarProducto.show()
  }

  onProductoSeleccionado({ data: _productoSeleccionado, origen }) {
    this.productoSeleccionado = _productoSeleccionado
    this.formHeader.get('producto_sku').setValue(_productoSeleccionado.sku)
    this.formatoProductoService.GetFormatosByCodigo(
      this.rutEmpresa,
      this.productoSeleccionado.codigo,
      ({ mensajes, respuesta }) => {
        this.optionsFormato = respuesta.registros.map(formato => ({ value: formato.formato_codigo, label: formato.formato_nombre, ...formato }))
        if (this.equivalencia_producto === null) {
          this.formValidatorsService.selectDefaultFormatoProducto(this.formHeader.get('formato_codigo_top'), this.optionsFormato)
        } else {
          this.formHeader.get("formato_codigo_top").setValue(this.equivalencia_producto.formato_codigo_top)
        }
      }
    )
  }

  onProductoNoEncontrado() {
    this.resetProductoDetails()
  }

  resetProductoDetails() {
    this.formHeader.get("producto_sku").reset()
    this.formHeader.get("producto_sku").setValue(null)
    this.formHeader.get("producto_sku").markAsUntouched()

    this.modalSeleccionarProducto.clearLast()

    // this.optionsFormato = []
    this.productoSeleccionado = null
  }

  createPayload() {
    const { cliente_proveedor_rut, producto_proveedor, detalle_producto, formato_codigo, activado, observacion, factor_equivalencia, formato_codigo_top } = this.formHeader.value

    const inputParams: { entidad: IEquivalenciaProducto } = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        cliente_proveedor_rut: this.rutService.QuitarDV(cliente_proveedor_rut),
        producto_proveedor,
        detalle_producto,
        formato_codigo,
        factor_equivalencia,
        producto_codigo: this.productoSeleccionado.codigo,
        formato_codigo_top,
        observacion: observacion ? observacion.trim() : '',
        activado
      }
    }
    return inputParams
  }

  create() {
    if (this.formHeader.get('observacion').value)
      this.formHeader.get('observacion').setValue(this.formHeader.get('observacion').value.trim())

    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid) {
      this.toastService.warning('Por favor complete todos los campos requeridos')
      return
    }

    const inputParams = this.createPayload()
    this.log('inputParams', JSON.stringify(inputParams))

    // this.loading = true
    this.equivalenciaProductoService.create(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      // const {  } = respuesta
      // this.loading = false
      this.onSuccess.emit()
      this.modalProductoEquivalencias.hide()
      this.toastService.success('Operación exitosa')
    })
  }

  update() {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid) {
      this.toastService.error('Ingrese Observación.')
      return
    }

    const inputParams = this.createPayload()
    inputParams.entidad.id = this.equivalencia_producto.id
    this.log('inputParams', JSON.stringify(inputParams))

    // this.loading = true
    this.equivalenciaProductoService.update(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      this.messageRendererService.showInfoMessages(mensajes)
      // const {  } = respuesta
      // this.loading = false
      this.onSuccess.emit()
      this.modalProductoEquivalencias.hide()
      this.toastService.success('Operación exitosa')
    })
  }

  abrirModalSeleccionarProveedor() {
    this.modalSeleccionarProveedor.show()
  }

  onProveedorSeleccionado({ data, origen }) {
    this.proveedorSeleccionado = data
    this.proveedorSeleccionado.rutFormato = this.rutService.AgregarDV(this.proveedorSeleccionado.rut)
    this.formHeader.get('cliente_proveedor_rut').setValue(this.proveedorSeleccionado.rutFormato)
    this.onProveedorChange.emit(this.headerData.proveedorSeleccionado)
  }

  onProveedorNoEncontrado() {
    this.proveedorSeleccionado = null
    this.clearProveeData()
  }
  clearProveeData() {
    this.clearContent()
    this.onProveedorChange.emit(null)
  }

  clearContent() {
    this.headerData = {}
    this.formValidatorsService.reset(this.formHeader)
  }
}
